import { React, useEffect, useState } from 'react'
import { Card, Image, InputGroup } from 'react-bootstrap';
import { Link, useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Col, Row, Button, ButtonGroup, ButtonToolbar, Table, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVideoCamera, faShareNodes, faDownload, faFileAudio, faUser, faLocation, faClock, faPerson, faArrowLeft, faAngleRight, faBook, faMessage } from '@fortawesome/free-solid-svg-icons';
import { faTwitter, faFacebook, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope, faPhone, faMapLocationDot, faMapLocation, faAddressCard, faAddressBook } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { serverurl } from '../../providers/ServerUrl';
import '../EventDetail.css';

export const Prayer = () => {


    /**********************************************
       POST CONTACT FORM DATA TO THE API
     **********************************************/

       const [buttontext, setButtonText] = useState('Send');
       const [message, setMessageText] = useState();
       const [successmessage, setSuccessMessage] = useState();
       const [errormessage, setErrorMessage] = useState();
   
       const [prayeruser_name, setPrayerName] = useState();
       const [prayeruser_email, setPrayerEmail] = useState();
       const [prayeruser_pnum, setPrayerPnum] = useState();
       const [prayeruser_request, setPrayerRequest] = useState();
   
       const navigate = useNavigate();
   
       const Save = async () => {
           setButtonText("Processing");
           if(prayeruser_name === "" || prayeruser_email === "" || prayeruser_pnum === "" || prayeruser_request === "") {
               setMessageText("error");
               setErrorMessage("All Fields are Required");
               setButtonText("Send");
           } else {
           try {
                         
               const items = { prayeruser_name, prayeruser_email, prayeruser_pnum, prayeruser_request };
               //console.warn(items);
               const result = await axios.post(serverurl + "/api/prayer", items);
               setMessageText("success");
               setSuccessMessage(result.data.message);
               setButtonText("Send");
               console.warn(result);
           
           } catch (error) {
               setMessageText("error");
               setErrorMessage("!!Sorry, Your Request Could Not Be Processed");
               setButtonText("Send");
               console.log(error);
           }
         }
       };





    return (
        <div>

            <div>
                <br></br><br></br>
                <div style={{ position: 'relative' }}>
                    <Image fluid src="images/img3.jpg" alt="Card image" id="bannerimg" />
                    <div id="banneroverlay">
                        <div id="bannerid" className='text-center'>
                            <p id="navhistory">
                                <Link to="/" id="homelink" reloadDocument>Home &nbsp; &#60; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Link>
                                <Link to="/prayeruser" reloadDocument className='text-white' id="currentlink">PRAYER REQUEST</Link>
                            </p>
                            <h4>Prayer</h4>
                        </div>
                    </div>
                </div>
            </div>


            <br></br><br></br>


            <div>
                <Container>
                    <Row>
                        <Col md={12}>
                            <Card id="deptcard">
                                <Card.Header style={{ backgroundColor: '#135592', color: '#fff', fontSize: '20px', textAlign: 'center' }}>
                                    Send In Your Prayer Request
                                </Card.Header>
                                <Card.Body>
                                    <Form>

                                        <InputGroup className="mb-3" controlId="">
                                            <Button variant="outline-secondary" id="button-addon1">
                                            <FontAwesomeIcon icon={faUser} />
                                            </Button>
                                            <Form.Control type="text" size="lg" placeholder="Full Name" style={{ fontSize: '16px', padding: '15px' }}
                                                value={prayeruser_name} onChange={(e) => setPrayerName(e.target.value)} />
                                        </InputGroup>

                                        <InputGroup className="mb-3" controlId="">
                                            <Button variant="outline-secondary" id="button-addon1">
                                            <FontAwesomeIcon icon={faEnvelope} />
                                            </Button>        
                                            <Form.Control type="email" size="lg" placeholder="Email" style={{ fontSize: '16px', padding: '15px' }}
                                                value={prayeruser_email} onChange={(e) => setPrayerEmail(e.target.value)} />
                                      
                                        </InputGroup>

                                        <InputGroup className="mb-3" controlId="">
                                            <Button variant="outline-secondary" id="button-addon1">
                                            <FontAwesomeIcon icon={faPhone} />
                                            </Button>
                                            <Form.Control type="text" size="lg" placeholder="Pnone Number" style={{ fontSize: '16px', padding: '15px' }}
                                                value={prayeruser_pnum} onChange={(e) => setPrayerPnum(e.target.value)} />
                                        </InputGroup>

                                        <InputGroup className="mb-3" controlId="">
                                            <Button variant="outline-secondary" id="button-addon1">
                                            <FontAwesomeIcon icon={faBook} />
                                            </Button>
                                            <Form.Control type="text" size="lg" placeholder="Request" style={{ fontSize: '16px', padding: '15px' }}
                                                value={prayeruser_request} onChange={(e) => setPrayerRequest(e.target.value)} />
                                        </InputGroup>

                                    </Form>
                                    <div>
                                        {
                                            message === 'success' ?
                                                <div className='alert alert-success alert-sm'>
                                                    {successmessage}
                                                </div> :
                                                ''
                                        }

                                        {
                                            message === 'error' ?
                                                <div className='alert alert-danger alert-sm'>
                                                    {errormessage}
                                                </div> :
                                                ''
                                        }
                                    </div>
                                    <ButtonToolbar
                                        className="justify-content-between"
                                        aria-label="Toolbar with Button groups"
                                    >

                                        <ButtonGroup className="me-4" aria-label="First group">
                                            {
                                                buttontext === "Processing" ?
                                                    <Button class="btn btn-danger" style={{ backgroundColor: '#249D59', color: '#fff', borderRadius: '0', border: 'none', fontWeight: 'bold' }} onClick={Save}>
                                                        {buttontext}
                                                    </Button> :
                                                    ''
                                            }

                                            {
                                                buttontext === "Send" ?
                                                    <Button class="btn btn-danger" style={{ backgroundColor: 'red', color: '#fff', borderRadius: '0', border: 'none', fontWeight: 'bold' }} onClick={Save}>
                                                        {buttontext}
                                                    </Button> :
                                                    ''
                                            }
                                        </ButtonGroup>
                                    </ButtonToolbar>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            <br></br>



        </div >
    )
}
